module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-1-b789086ebb9f49764b239f579bb066c3.png";